import { HttpStatus } from '@/enums/httpStatus';
import { ORIGINS } from '@/enums/reporter';

// Mapping to match internal vue route name with origin for mixpanel
const routesToOrigin = {
  predictive_models: ORIGINS.predictive_models,
  'view-campaign': ORIGINS['view-campaign'],
  network: ORIGINS['network'],
  profile: ORIGINS.profile
};

// HTTPS statuses and error codes that should not be logged as errors on Bugsnag
const nonLoggableResponses = {
  statuses: [
    HttpStatus.UNAUTHORIZED,
    HttpStatus.FORBIDDEN,
    HttpStatus.CONFLICT,
    HttpStatus.NOT_FOUND,
    HttpStatus.UNPROCESSABLE_ENTITY
  ],
  codes: [810, 801]
};

/**
 * Allows to get the mixpanel origin according to a given route name
 * @param routeName
 * @returns Mixpanel origin value
 */
export function getOriginFromRoute(routeName) {
  return routesToOrigin[routeName];
}

/**
 * Returns if we need to send this error to bugsnag
 */
export function getShouldNotifyBugSnag(response) {
  if (
    nonLoggableResponses.statuses.includes(response?.status) ||
    nonLoggableResponses.codes.includes(response?.data?.code)
  ) {
    return false;
  } else {
    return true;
  }
}
